import Helpers from '..';
/**
 * Checks if desktop side ad should be injected in case no other ad has.
 * @param {Number} bodyIndex Current body index in array.
 * @param {Array} injectedArray Original graphQL body array injected with elements.
 * @param {Array} bodyElements Array of elements.
 * @param {Number} typeToStartCount Type of last element to start counting from.
 * @param {Object} props Props passed down from the component using the injection logic.
 * @returns {Boolean}
 */
const shouldInjectFinalSideAd = ({
  bodyElements,
  bodyIndex,
  injectedArray,
  props,
  typeToStartCount = 'DESKTOP_SIDE_ADVERT',
}) => {
  let shouldInject = false;

  if (Helpers.isLastIndexOfArray({ bodyIndex, bodyElements })) {
    if (Helpers.shouldInjectLastAd({ injectedArray, props, typeToStartCount })) { shouldInject = true; }
  }

  return shouldInject;
};

export default shouldInjectFinalSideAd;
